import React, { useState, useRef, useEffect } from 'react'
import PageHeader from '../../Components/PageHeader/PageHeader'
import { hasError } from '../../utils'
import { BookOpenIcon } from 'lucide-react'
import AppInput from '../../Components/AppInput/AppInput';
import { useDispatch, useSelector } from 'react-redux';
import AppButton from '../../Components/AppButton/AppButton';
import { BookValidationScheema } from '../../ValidationScheema/BookValidation';
import { setApiErrorJson } from '../../Redux/Actions/ApiAction';
import { addBook, updateBook } from '../../Constant/Constant';
import { ApiHit } from '../../Api/ApiHit';
import toast from 'react-hot-toast';
import { statusOptions } from '../../Constant/Options';
import AppSelect from '../../Components/AppSelect/AppSelect';
import { getCahbookUser, setCashbookUser, getSelectedAccount, setSelectedBook } from '../../Storage/Storage';

function AddBooks({ isEditMode, onClose }) {
  const [submitLoading, setSubmitLoading] = useState(false);
  const ApiReducer = useSelector((state) => state.ApiReducer);

  const user = getCahbookUser();


  console.log('user', user);

  const dispatch = useDispatch();
  const originalDataRef = useRef(null);

  // Store original data
  useEffect(() => {
    if (isEditMode && ApiReducer?.apiJson) {
      originalDataRef.current = { ...ApiReducer.apiJson };
    }
  }, []);

  const handleSubmit = () => {
    setSubmitLoading(true);
    BookValidationScheema(ApiReducer?.apiJson, isEditMode).then((error) => {
      dispatch(setApiErrorJson(error))
      if (Object.keys(error).length === 0) {
        const apiEndpoint = isEditMode ? updateBook : addBook;

        let apiData;

        if (isEditMode) {
          // For update: only send changed fields + _id
          const changedFields = { _id: ApiReducer?.apiJson?._id };

          Object.keys(ApiReducer?.apiJson).forEach((key) => {
            if (key !== '_id' && key !== '__v' && key !== 'createdAt' && key !== 'updatedAt') {
              const currentValue = ApiReducer?.apiJson[key];
              const originalValue = originalDataRef.current?.[key];

              // Check if value has changed
              if (currentValue !== originalValue) {
                // Convert status to boolean if needed
                if (key === 'status') {
                  changedFields[key] = currentValue === "true" || currentValue === true ? true : false;
                } else {
                  changedFields[key] = currentValue;
                }
              }
            }
          });

          apiData = changedFields;
        } else {
          // For add: send all data
          apiData = {
            ...ApiReducer?.apiJson,
            accountId: getSelectedAccount()?._id,
            status:
              ApiReducer?.apiJson?.status === "true" ||
                ApiReducer?.apiJson?.status === true
                ? true
                : false,
          };
        }

        ApiHit(apiData, apiEndpoint)
          .then((res) => {
            console.log("res", res);
            const successCode = isEditMode ? 200 : 201;
            if (res?.statusCode === successCode) {

              if (!isEditMode && res?.data) {
                const currentUser = getCahbookUser();
                if (currentUser) {
                  currentUser.bookId = [...(currentUser.bookId || []), res.data];
                  setCashbookUser(currentUser);
                }
                setSelectedBook(res.data);
              }

              toast.success(
                isEditMode
                  ? "Book updated successfully"
                  : "Book added successfully"
              );
              if (!isEditMode) {
                window.location.pathname = '/cashbook'
              } else {
                onClose();
              }
            } else {
              toast.error(res?.error || "Something went wrong");
            }
          })
          .finally(() => {
            setSubmitLoading(false);
          });
      } else {
        setSubmitLoading(false);
      }
    });
  };

  return (
    <div className='p-5'>
      <PageHeader
        title={isEditMode ? 'Edit Book' : 'Add Book'}
        description={isEditMode ? 'Update book information and details' : 'Create a new book and manage'}
      />
      <div>
        <AppInput
          title="Book Name"
          placeholder="Enter book name"
          name="bookName"
          important={true}
          error={hasError('bookName', ApiReducer)}
          icon={<BookOpenIcon size={18} />}
          disabled={submitLoading}
        />

        <AppSelect
          title="Status"
          name="status"
          options={statusOptions}
          placeholder="Select status"
          disabled={submitLoading}
          error={hasError('status', ApiReducer)}
        />
      </div>

      <div className='mt-5 flex justify-end'>
        <AppButton
          buttontext={submitLoading ? "Processing..." : (isEditMode ? "Update Book" : "Add Book")}
          onClick={handleSubmit}
          disabled={submitLoading}
        />
      </div>
    </div>
  )
}

export default AddBooks
